import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio916Dropdown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 19,
	viewBox: "0 0 14 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.2 1.6888H2.8C2.0268 1.6888 1.4 2.28576 1.4 3.02214V15.6888C1.4 16.4252 2.0268 17.0221 2.8 17.0221H11.2C11.9732 17.0221 12.6 16.4252 12.6 15.6888V3.02214C12.6 2.28576 11.9732 1.6888 11.2 1.6888ZM2.8 0.355469C1.2536 0.355469 0 1.54938 0 3.02214V15.6888C0 17.1616 1.2536 18.3555 2.8 18.3555H11.2C12.7464 18.3555 14 17.1616 14 15.6888V3.02214C14 1.54938 12.7464 0.355469 11.2 0.355469H2.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.39961 16.3555C8.01301 16.3555 7.69961 16.057 7.69961 15.6888C7.69961 15.3206 8.01301 15.0221 8.39961 15.0221C9.55941 15.0221 10.4996 14.1267 10.4996 13.0221V11.6888C10.4996 11.3206 10.813 11.0221 11.1996 11.0221C11.5862 11.0221 11.8996 11.3206 11.8996 11.6888V15.6888C11.8996 16.057 11.5862 16.3555 11.1996 16.3555H8.39961ZM5.24961 2.35547C5.63621 2.35547 5.94961 2.65395 5.94961 3.02214C5.94961 3.39033 5.63621 3.6888 5.24961 3.6888C4.28311 3.6888 3.49961 4.43499 3.49961 5.35547V7.35547C3.49961 7.72366 3.18621 8.02214 2.79961 8.02214C2.41301 8.02214 2.09961 7.72366 2.09961 7.35547V3.02214C2.09961 2.65395 2.41301 2.35547 2.79961 2.35547H5.24961Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAspectRatio916Dropdown);
export default ForwardRef;
